import { media, styled } from '@styles';
import { Container } from '@components/templates/Container';

export const Wrapper = styled(Container)`
  margin-top: 240px;
  display: flex;

  margin-top: 240px;
  display: flex;

  ${media.largeScreen`
    margin-top: 207px;
    width: 75vw;
  `}
  ${media.mediumScreen`
    margin-top: 142px;
    flex-direction: column;
    align-items: center;
  `}
  ${media.smallScreen`
    margin-top: 120px;
  `}
  ${media.xSmallScreen`
    width: 85vw;
  `}
`;

export const Title = styled.div`
  max-width: 78px;
  margin-right: 9.8vw;
  font-family: ${(props) => props.theme.typography.boldFontFamily};
  font-size: ${(props) => props.theme.typography.baseFontSize};
  font-style: normal;
  font-weight: normal;
  line-height: 160%;
  color: ${(props) => props.theme.colors.baseFont};

  ${media.largeScreen`
    max-width: 69px;
    margin-right: 5.78vw;
    font-size: 16px;
  `}
  ${media.mediumScreen`
    max-width: 100%;
    margin-right: 0;
  `}
`;

export const List = styled.ul`
  display: flex;
  align-items: center;
  ${media.smallScreen`
    flex-wrap: wrap;
    justify-content: center;
  `}
`;

export const Item = styled.li`
  height: 60px;

  &:not(:last-child) {
    margin-right: 4.6875vw;
  }

  ${media.largeScreen`
    height: 48px;

    &:not(:last-child) {
      margin-right: 3.75vw;
    }
  `}

  ${media.mediumScreen`
    margin-top: 37px;
    height: 37px;

    &:not(:last-child) {
      margin-right: 4.82vw;
    }
  `}

  ${media.smallScreen`
    height: 36px;

    &:not(:last-child) {
      margin-right: 7.375vw;
    }

    &:nth-child(3n) {
      margin-right: 0;
    }
  `}

  img {
    max-height: 100%;
    position: relative;
    top: 50%;
    transform: translateY(-50%);

    ${media.largeScreen`
      max-width: 120px;
    `}

    ${media.mediumScreen`
      max-width: 96px;
    `}

    ${media.smallScreen`
      max-width: 90px;
    `}
  }
`;
